import { render, staticRenderFns } from "./PreviewTemplateSidebar.vue?vue&type=template&id=34f5a80b&scoped=true&"
import script from "./PreviewTemplateSidebar.vue?vue&type=script&lang=js&"
export * from "./PreviewTemplateSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5a80b",
  null
  
)

export default component.exports